export const PIXELS_PER_SECOND = 5;

export function seconds_to_pixels(seconds: number) {
  return seconds * PIXELS_PER_SECOND;
}

export function pixels_to_second(pixels: number) {
  return pixels / PIXELS_PER_SECOND;
}
